export default __webpack_public_path__ + "static/media/Mirrored-Glass-Truck-Hero-480px-160px.jpg.ff5c8d5b.webp";